import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

import { IClientLead } from "../../models/ClientLead";

import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyClientLead } from "./EmptyClientLead";


const schema = yup.object({
    companyName: yup.string().required("Company Name is required*").min(3),
    url: yup.string().url().required("URL is required*").min(3),
    location: yup.string().required("Location is required*"),
    noOfEmployee: yup.number().required("No Of Employee is required*").positive()
});

interface Iprops {
    singleData: IClientLead,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IClientLead>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])


    const saveToDB = async (body: IClientLead) => {
        const method = props.singleData.lead_ID ? "PUT" : "POST";
        const message = props.singleData.lead_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Client_Lead", method, body, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyClientLead);
    }

    function onSubmit(data: IClientLead) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit ClientLead" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required label="Company Name" control={control} name="companyName" error={errors.companyName?.message} />
                <JVInput required label="Linkedin URL/Portal URL" control={control} name="url" error={errors.url?.message} />
                <JVInput required label="Location" control={control} name="location" error={errors.location?.message} />
                <JVInput required label="No of Employee" control={control} name="noOfEmployee" error={errors.noOfEmployee?.message} />

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
